(function($) {
    $.fn.avia_sc_tabs = function(options) {
        var defaults = {
            heading: '.tab',
            content: '.tab_content',
            active: 'active_tab',
            sidebar: false
        };
        var win = $(window),
            options = $.extend(defaults, options);
        return this.each(function() {
            var container = $(this),
                tab_titles = $('<div class="tab_titles"></div>').prependTo(container),
                tabs = $(options.heading, container),
                content = $(options.content, container),
                newtabs = false,
                oldtabs = false;
            container.addClass("tab-loaded");
            newtabs = tabs.clone();
            oldtabs = tabs.addClass('fullsize-tab').attr('aria-hidden', true);
            tabs = newtabs;
            tabs.prependTo(tab_titles).each(function(i) {
                var tab = $(this),
                    the_oldtab = false;
                if (newtabs) {
                    the_oldtab = oldtabs.eq(i);
                }
                tab.addClass('tab_counter_' + i).on('click', function(e) {
                	e.preventDefault();
                    var group_tab = '.tab_content.' + $(this).data("group-tab");
                        open_content(tab, i, the_oldtab, group_tab);
                    return false;
                });
                tab.on('keydown', function(objEvent) {
                    if (objEvent.keyCode === 13) {
                        tab.trigger('click');
                    }
                });
                if (newtabs) {
                    the_oldtab.on('click', function(e) {
                    	e.preventDefault();
                        group_tab = false;
                        //var group_tab = '.tab_content.' + $(tab).data("group-tab");                        
                        open_content(the_oldtab, i, tab, group_tab);
                        return false;
                    });
                    the_oldtab.on('keydown', function(objEvent) {
                        if (objEvent.keyCode === 13) {
                            the_oldtab.trigger('click');
                        }
                    });
                }
            });
            set_size();
            win.on("debouncedresize", set_size);

            function set_size() {
                if (!options.sidebar) {
                    return;
                }
                content.css({
                    'min-height': tab_titles.outerHeight() + 1
                });
            }

            function open_content(tab, i, alternate_tab, group_tab) {
                if (!tab.is('.' + options.active)) {
                    $('.' + options.active, container).removeClass(options.active);
                    $('.' + options.active + '_content', container).attr('aria-hidden', true).removeClass(options.active + '_content');
                    tab.addClass(options.active);

                    if (alternate_tab) {
                        alternate_tab.addClass(options.active);
                    }
                    var active_c = content.eq(i).addClass(options.active + '_content').attr('aria-hidden', false);
                    if (typeof click_container != 'undefined' && click_container.length) {
                        sidebar_shadow.height(active_c.outerHeight());
                    }

                    var groupTab = tab.data("group-tab");
                    $(".tab[data-group-tab=" + groupTab + "]").trigger("click");
                }
            }

        });
    };
}(jQuery));
